/**
 * The tab title of a screen (BUG-15: one `<title>` served every screen, so three open tabs — the
 * feed, a listing and the plans — read the same and could not be told apart in history or bookmarks).
 *
 * Format: `<screen> · GAC`. The screen part is whatever names the screen best for a person scanning
 * tabs — the car for a listing, the action for a deal. Anything numeric that gets in here is
 * pinned to `en-US` by the caller (see `src/utils/money.ts`); the title never formats on its own.
 */
export const APP_TITLE = 'GAC';

/** What the tab says before any screen has claimed it — the `<title>` of `index.html`. */
export const DEFAULT_DOCUMENT_TITLE = 'GAC — cars, secured by smart contract';

/**
 * Joins the screen's parts into one title. Empty and missing parts are dropped, so a screen can pass
 * `[car?.name, 'Rental']` while the car is still loading and get a sensible `Rental · GAC` meanwhile.
 */
export const formatDocumentTitle = (...parts: (string | null | undefined)[]): string => {
  const named = parts.map((part) => (part ?? '').trim()).filter((part) => part.length > 0);

  return [...named, APP_TITLE].join(' · ');
};

/** `Make Model Year` of a car as a title part — the three facts that tell listings apart. */
export const carTitle = (car: {
  make?: { name?: string } | null;
  model?: { name?: string } | null;
  year?: number | string | null;
}): string =>
  [car.make?.name, car.model?.name, car.year == null ? '' : String(car.year)]
    .map((part) => (part ?? '').trim())
    .filter((part) => part.length > 0)
    .join(' ');
